import { motion } from "framer-motion";
import { IMAGES, KEY_DATES } from "@/lib/constants";
import { Countdown } from "@/components/Countdown";
import { useI18n } from "@/i18n/I18nContext";

export const Hero = () => {
  const { t } = useI18n();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.heroPoster} alt="Scène présidentielle" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" />
        <div className="absolute inset-0 spotlight-glow animate-spotlight" aria-hidden="true" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-16 w-full">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.15 }}
          className="font-serif text-4xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-white max-w-4xl"
          data-testid="hero-title"
        >
          {t("hero.titleLine1")}<br />
          <span className="italic text-theatre-gold">{t("hero.titleLine2")}</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.3 }}
          className="mt-8 max-w-2xl text-base md:text-lg text-neutral-300 leading-relaxed"
          data-testid="hero-subtitle"
        >
          {t("hero.subtitle")}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.45 }}
          className="mt-10 flex flex-wrap gap-4"
        >
          <button
            data-testid="hero-cta-preinscription"
            onClick={() => scrollTo("preinscription")}
            className="bg-theatre-red hover:bg-theatre-redhover text-white px-8 py-4 text-xs uppercase tracking-[0.25em] transition-colors duration-300"
          >
            {t("hero.ctaCandidat")}
          </button>
          <button
            data-testid="hero-cta-projet"
            onClick={() => scrollTo("projet")}
            className="border border-theatre-gold text-theatre-gold px-8 py-4 text-xs uppercase tracking-[0.25em] hover:bg-theatre-gold hover:text-black transition-colors duration-300"
          >
            {t("hero.ctaProjet")}
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.6 }}
          className="mt-16"
        >
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-neutral-400 mb-5">
            {t("hero.countdownLabel")}
          </p>
          <Countdown target={KEY_DATES.preinscription} testId="hero-countdown" />
        </motion.div>
      </div>
    </section>
  );
};
